import { createContext } from "react";

export const HoverContext = createContext();
